/** Namespaces preferences per OIDC subject without storing the raw subject in the key. */
export function hashSubject(subject: string): string {
  let h1 = 0x811c9dc5;
  let h2 = 0x01000193;
  for (let i = 0; i < subject.length; i++) {
    const code = subject.charCodeAt(i);
    h1 = Math.imul(h1 ^ code, 0x01000193);
    h2 = Math.imul(h2 ^ (code + i), 0x01000193);
  }
  return `${(h1 >>> 0).toString(16).padStart(8, '0')}${(h2 >>> 0).toString(16).padStart(8, '0')}`;
}

/** Used when no user is signed in; not a hash of PII. */
export const ANONYMOUS_SUBJECT_HASH = 'anonymous';
